import type { ReportTrendSeries } from '@chukua/common';

export interface ChartPoint {
  period: string;
  /** Major units for money, the plain value otherwise. */
  value: number;
}

export interface ChartSeries {
  label: string;
  points: ChartPoint[];
}

function valueOf(metric: ReportTrendSeries['points'][number]['metric']): number {
  if (metric.kind === 'money') return metric.amountMinor / MINOR_PER_MAJOR[metric.currency];
  if (metric.kind === 'ratio') return metric.denominator === 0 ? 0 : metric.numerator / metric.denominator;
  return metric.value;
}

/** Minor units per major unit, as `Money` has them; the chart only needs a number to draw, the table beside it carries the exact figure. */
const MINOR_PER_MAJOR = { KES: 100, USD: 100, UGX: 1, TZS: 100 } as const;

/** One chart per series: money of different currencies never shares an axis. */
export function toChartSeries(series: ReportTrendSeries[]): ChartSeries[] {
  return series.map((entry) => ({
    label: entry.currency ?? 'Total',
    points: entry.points.map((point) => ({ period: point.period, value: valueOf(point.metric) })),
  }));
}
